'use strict';

angular.module('shiftTraderApp')
    .directive('saSlideSwipeContainer', ['$timeout', function($timeout) {
      var SWIPE_SENSITIVITY = 25;

    return {
      transclude: true,
      template: '<div class="slide_swipe_wrapper"><div class="slide_swipe_container" ng-transclude></div>' +
                '<div sa-page-indicator="" page-class="sa_slide" active-page="state.currentPageIndex" num-pages="slides.length"></div></div>',
      //priority: 100,
      link: function(scope, element, attr) {
        if (attr.page) {
          scope.page = parseInt(attr.page);
        }

        scope.setWidthOfContainer = function() {
          console.log('setWidthOfContainer: ' + scope.slides.length);
          $(element).find('.slide_swipe_container').css({
            width: 100 * scope.slides.length + '%'
          });
        };

        $timeout(function() {
          scope.setWidthOfContainer();

          $(element).parent('.modal-content').css({height: $(element).parent('.modal-dialog').height() + 'px'});
        }, 100);

        scope.adjustCurrentPageIndex = function(direction) {
          if (direction === 1) {
            if ((scope.state.currentPageIndex) < (scope.slides.length - 1)) {
              scope.goTo(scope.state.currentPageIndex + 1);
            }
          } else {
            if (scope.state.currentPageIndex > 0) {
              scope.goTo(scope.state.currentPageIndex - 1);
            }
          }
        };

        scope.$on('sa:slideSwipeContainer:advancePage', function(event, data) {
          scope.adjustCurrentPageIndex(data);
        });

        var slideSwipeContainer = $(element).find('.slide_swipe_container');

        /**
         * Perform any setup for the drag actions.
         */

        function terminatePan(evt, percentage) {
          if( evt.velocityX > 1 ) {
            scope.goTo( scope.state.currentPageIndex - 1 );
          } else if( evt.velocityX < -1 ) {
            scope.goTo( scope.state.currentPageIndex + 1 )
          } else {
            if (percentage <= -( SWIPE_SENSITIVITY / scope.slides.length)) {
              scope.goTo( scope.state.currentPageIndex + 1 );
            } else if( percentage >= ( SWIPE_SENSITIVITY / scope.slides.length ) ) {
              scope.goTo(scope.state.currentPageIndex - 1);
            } else {
              scope.goTo( scope.state.currentPageIndex );
            }
          }
        }

        var hammerManager = new Hammer.Manager(slideSwipeContainer[0]);
        var panTimeout;

        hammerManager.add(new Hammer.Pan({ threshold: 15, pointers: 1, direction: Hammer.DIRECTION_HORIZONTAL}));

        hammerManager.on('panleft panright panstart panend', function(e) {
          if (e.additionalEvent ==='panup' || e.additionalEvent === 'pandown') {
            return;
          }

          if ((Math.abs(e.deltaY) * 2.0) > Math.abs(e.deltaX)) {
            return;
          }
          // 4e. Calculate pixel movements into 1:1 screen percents so gestures track with motion
          var percentage = 100 / scope.slides.length * e.deltaX / window.innerWidth;

          // 4f. Multiply percent by # of slide we’re on
          var percentageCalculated = percentage - 100 / scope.slides.length * scope.state.currentPageIndex;


          if (e.type === 'panright' || e.type === 'panleft') {
            // 4g. Apply transformation
            slideSwipeContainer.css({
              transform: 'translateX( ' + percentageCalculated + '% )'
            });
          }

          if (panTimeout) {
            $timeout.cancel(panTimeout);
          }

          // 4h. Snap to slide when done
          if ( e.isFinal) {
            if (e.type === 'panend') {
              terminatePan(e, percentage);
            } else {
              panTimeout = $timeout(function() {
                terminatePan(e, percentage);
              }, 100);
            }
          }
        });

        scope.goTo = function(number) {
          // 5a. Stop it from doing weird things like moving to slides that don’t exist
          if (number < 0) {
            scope.state.currentPageIndex = 0;
          } else if (number > scope.slides.length - 1) {
            scope.state.currentPageIndex = scope.slides.length - 1;
          } else {
            scope.state.currentPageIndex = number;
          }

          // 5b. Apply transformation & smoothly animate via .is-animating CSS
          slideSwipeContainer.addClass('animating');
          var percentage = -( 100 / scope.slides.length ) * scope.state.currentPageIndex;
          slideSwipeContainer.css({
            transform: 'translateX( ' + percentage + '% )'
          });

          if (scope.state.slideTimer) {
            $timeout.cancel(scope.state.slideTimer);
          }

          scope.state.slideTimer = $timeout(function() {
            slideSwipeContainer.removeClass('animating' );
          }, 400);

          // 5c. Update the counters
          // var pagination = slideSwipeContainer.parentElement.querySelectorAll( slider.sliderPaginationSelector + ' > *' );
          // var n = 0;
          // for( n; n < pagination.length; n++ ) {
          //   var className = n == scope.state.currentPageIndex ? 'is-active' : '';
          //   pagination[n].className = className;
          // }
        };

      },
      controller: ['$scope', function($scope) {

        var vm = this,
            slides = vm.slides = $scope.slides = [];

        $scope.state = {
          currentPageIndex: $scope.loadToPage ? parseInt($scope.loadToPage) : 0,
          numberOfSlides: 0
        };

        vm.registerSlide = function registerSlide(slideHash) {
          console.log(slideHash);
          slides.push(slideHash);
        };

        vm.getViewportWidth = function() {
          return $scope.containerWidth;
        };
      }]
    };
  }]);
